<header class="header-bar">
  <div class="header-school">
    <div class="school-mark">
      @if (schoolLogoUrl) {
        <img class="school-logo" [src]="schoolLogoUrl" alt="School logo" (error)="handleLogoError()" />
      } @else {
        <i class="fas fa-school"></i>
      }
    </div>
    <div class="school-copy">
      <span class="school-kicker">{{ orgKicker }}</span>
      <span class="school-name">{{ schoolName }}</span>
    </div>
    @if (showSchoolSwitch) {
      <div class="school-divider"></div>
      <button class="btn-change btn-change--compact" (click)="openSchoolChange()" title="Switch school">
        <i class="fas fa-exchange-alt"></i>
      </button>
    }
    <div class="header-spacer"></div>

    <!-- App-specific header widgets (e.g. Academics academic-year picker). -->
    <ng-content select="[headerActions]"></ng-content>

    @if (modules.length > 0) {
      <div class="module-switcher" (click)="toggleModuleMenu($event)">
        <button class="module-switcher__trigger" type="button">
          @if (currentModule?.image) {
            <img class="module-switcher__icon-img" [src]="currentModule?.image" alt="" />
          } @else {
            <span class="module-switcher__icon">
              <i class="fas fa-layer-group"></i>
            </span>
          }
          <span class="module-switcher__label">{{ currentModule?.moduleName || moduleName || 'Modules' }}</span>
          <i class="fas fa-chevron-down module-switcher__chevron" [class.module-switcher__chevron--open]="showModuleMenu"></i>
        </button>

        @if (showModuleMenu) {
          <div class="module-menu" (click)="$event.stopPropagation()">
            <div class="module-menu__header">
              <div class="module-menu__title">
                <span class="module-menu__title-icon">
                  <i class="fas fa-layer-group"></i>
                </span>
                <div>
                  <span class="module-menu__eyebrow">Switch Module</span>
                  <strong>Choose workspace</strong>
                </div>
              </div>
              @if (currentModule) {
                <span class="module-menu__current">{{ currentModule!.moduleName }}</span>
              }
            </div>
            <div class="module-menu__meta">
              <span>{{ filteredModules.length }} shown</span>
              <span>{{ modules.length }} total modules</span>
            </div>
            <div class="module-menu__search">
              <i class="fas fa-search"></i>
              <input type="text" [(ngModel)]="moduleSearch" placeholder="Search modules..." />
              @if (moduleSearch) {
                <button type="button" (click)="moduleSearch = ''">
                  <i class="fas fa-times"></i>
                </button>
              }
            </div>
            <div class="module-menu__grid">
              @for (module of filteredModules; track module.moduleName) {
                <button
                  class="module-menu__item"
                  [class.module-menu__item--active]="currentModule?.route === module.route"
                  type="button"
                  (click)="switchModule(module)">
                  @if (module.image) {
                    <span class="module-menu__icon-shell">
                      <img class="module-menu__icon-img" [src]="module.image" alt="" />
                    </span>
                  } @else {
                    <span class="module-menu__icon module-menu__icon-shell">
                      <i class="fas fa-cube"></i>
                    </span>
                  }
                  <span class="module-menu__item-copy">
                    <span class="module-menu__item-name">{{ module.moduleName }}</span>
                  </span>
                  @if (currentModule?.route === module.route) {
                    <span class="module-menu__check">
                      <i class="fas fa-check"></i>
                    </span>
                  }
                </button>
              } @empty {
                <div class="module-menu__empty">
                  <i class="fas fa-search"></i>
                  <span>No modules found</span>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }

    <div class="profile-switcher" (click)="toggleProfileMenu($event)">
      <button class="profile-switcher__trigger" type="button" [class.profile-switcher__trigger--active]="showProfileMenu">
        <span class="profile-switcher__avatar">{{ initials }}</span>
        <span class="profile-switcher__copy">
          <span class="profile-switcher__name">{{ employeeName }}</span>
        </span>
        <i class="fas fa-chevron-down profile-switcher__chevron" [class.profile-switcher__chevron--open]="showProfileMenu"></i>
      </button>

      @if (showProfileMenu) {
        <div class="profile-menu" (click)="$event.stopPropagation()">
          <div class="profile-menu__header">
            <span class="profile-menu__avatar">{{ initials }}</span>
            <div class="profile-menu__copy">
              <span class="profile-menu__eyebrow">Signed in as</span>
              <span class="profile-menu__name">{{ employeeName }}</span>
              <span class="profile-menu__school">{{ schoolName }}</span>
            </div>
          </div>
          <div class="profile-menu__status">
            <span class="profile-menu__status-dot"></span>
            <span>{{ sessionLabel }} session active</span>
          </div>
          <div class="profile-menu__divider"></div>
          <button class="profile-menu__item" type="button" (click)="openMyProfile()">
            <span class="profile-menu__item-icon">
              <i class="fas fa-user"></i>
            </span>
            <span class="profile-menu__item-copy">
              <strong>My Profile</strong>
              <small>Account and profile details</small>
            </span>
            <i class="fas fa-chevron-right profile-menu__item-arrow"></i>
          </button>
          <button class="profile-menu__item profile-menu__item--danger" type="button" (click)="logout()">
            <span class="profile-menu__item-icon">
              <i class="fas fa-sign-out-alt"></i>
            </span>
            <span class="profile-menu__item-copy">
              <strong>Logout</strong>
              <small>End this browser session</small>
            </span>
            <i class="fas fa-chevron-right profile-menu__item-arrow"></i>
          </button>
        </div>
      }
    </div>
  </div>
</header>

@if (showSchoolChange) {
  <spectrum-school-change (closed)="closeSchoolChange()" />
}
